import { render, staticRenderFns } from "./DealInsights.vue?vue&type=template&id=336903da&scoped=true&"
import script from "./DealInsights.vue?vue&type=script&lang=js&"
export * from "./DealInsights.vue?vue&type=script&lang=js&"
import style0 from "./DealInsights.vue?vue&type=style&index=0&id=336903da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336903da",
  null
  
)

export default component.exports